import React from 'react'
import UnauthorizedCard from '../../components/UnauthorizedCard'

export default function UnauthorizedContent() {
    return (
        <div className="page-body">
            <UnauthorizedCard />
        </div>
    )
}
